import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { Button, Card } from "react-bootstrap";
import AdminSidebar from "../AdminSidebar";
import { IoMdAddCircle } from "react-icons/io";
import Select from "react-select";
import ToastNotification from "../../components/ToastNotification/ToastNotification";
import axios from 'axios';
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import ConfirmDialog from "../../components/ToastNotification/ConfirmModal";
import { RiChatDeleteLine } from "react-icons/ri";
const SubscriptionPlan = () => {
  const [showForm, setShowForm] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [isEditMode, setIsEditMode] = useState(false);
  const [services, setServices] = useState([]);
  const [editingCompanyId, setEditingCompanyId] = useState(null);
  const [plans, setPlan] = useState([]);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [statusFilter, setStatusFilter] = useState("active");
  const [formData, setFormData] = useState({
    name: "",
    code: '',
    sale_price: "",
    mrp: '',
    months: '',
    duration: '',
    service_name: [],
    sub_img: null,
    order_no: '',
    description: ''
  });
  const [selectedServices, setSelectedServices] = useState([{
    sId: "",
    name: "",
    sale_price: 0,
    no_times: 1
  }]);
  const [confirmDialog, setConfirmDialog] = useState({
    show: false,
    title: '',
    message: '',
    onConfirm: null
  });
  const showConfirmDialog = ({
    title,
    message,
    onConfirm
  }) => {
    setConfirmDialog({
      show: true,
      title,
      message,
      onConfirm: () => {
        onConfirm();
        setConfirmDialog({
          ...confirmDialog,
          show: false
        });
      }
    });
  };
  const handleAddServiceRow = () => {
    setSelectedServices(prev => [...prev, {
      sId: "",
      name: "",
      sale_price: 0,
      s_type: "Daily",
      no_times: 1
    }]);
  };
  const handleRemoveServiceRow = index => {
    const updated = selectedServices.filter((_, i) => i !== index);
    setSelectedServices(updated);
    setFormData(prev => ({
      ...prev,
      service_name: updated
    }));
  };
  const handleServiceSelect = (index, serviceId) => {
    const selected = services.find(s => s.value == serviceId);
    const updated = [...selectedServices];
    updated[index] = {
      sId: selected?.value || "",
      name: selected?.label || "",
      sale_price: selected?.sale_price || 0,
      no_times: updated[index].no_times || 1,
      s_type: updated[index].s_type || "Daily"
    };
    setSelectedServices(updated);
    setFormData(prev => ({
      ...prev,
      service_name: updated
    }));
  };
  const handleTimeChange = (index, value) => {
    const updated = [...selectedServices];
    updated[index].no_times = Number(value) || 1;
    setSelectedServices(updated);
    setFormData(prev => ({
      ...prev,
      service_name: updated
    }));
  };
  const inputStyle = {
    background: "#1e293b",
    color: "#fff",
    border: "1px solid #334155"
  };
  const [toast, setToast] = useState({
    show: false,
    message: '',
    bg: 'success'
  });
  const showToast = (msg, bg = 'success') => {
    setToast({
      show: true,
      message: msg,
      bg
    });
  };
  const monthOptions = Array.from({
    length: 12
  }, (_, i) => ({
    value: i + 1,
    label: `${i + 1} month${i + 1 > 1 ? 's' : ''}`
  }));
  const handleInputChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => {
      const updated = {
        ...prev,
        [name]: value
      };
      return updated;
    });
  };
  const handleMonthChange = selectedOption => {
    setFormData(prev => ({
      ...prev,
      months: selectedOption?.value || ""
    }));
  };
  const handleCancel = () => {
    setShowForm(false);
    setIsEditMode(false);
    resetForm();
  };
  const handleSubmit = async e => {
    e.preventDefault();
    if (!formData.name) {
      showToast("Plan name is required!", "danger");
      return;
    }
    try {
      let res;
      const sendData = new FormData();
      sendData.append("name", formData.name);
      sendData.append("sale_price", formData.sale_price);
      sendData.append("mrp", formData.mrp);
      sendData.append("code", formData.code);
      sendData.append("months", formData.months);
      sendData.append("duration", formData.duration);
      sendData.append("order_no", formData.order_no);
      sendData.append("description", formData.description);
      sendData.append("service_name", JSON.stringify(selectedServices));
      if (formData.sub_img) {
        const maxSizeMB = 2;
        const fileSizeMB = formData.sub_img.size / (1024 * 1024);
        if (fileSizeMB > maxSizeMB) {
          showToast("Image size must be less than 2MB!", "danger");
          return;
        }
        sendData.append("sub_img", formData.sub_img);
      }
      if (isEditMode) {
        res = await axios.put(`https://api.sweepydo.in/update-subscription-plan/${formData.id}`, sendData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });
      } else {
        res = await axios.post("https://api.sweepydo.in/add-subscription-plan", sendData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });
      }
      showToast(isEditMode ? "Subscription plan Updated Successfully!" : "Subscription plan Added Successfully!", "success");
      setShowForm(false);
      setIsEditMode(false);
      resetForm();
      fetchPlan();
    } catch (err) {
      console.error("❌ Error:", err.response?.data || err.message);
      showToast(err.response?.data?.message || "Failed to save service!", "danger");
    }
  };
  const handleEdit = async form => {
    setIsEditMode(true);
    const parsedServices = typeof form.service_name === "string" ? JSON.parse(form.service_name || "[]") : form.service_name || [];
    setFormData({
      id: form.id,
      name: form.name || "",
      code: form.code || "",
      sale_price: form.sale_price || "",
      mrp: form.mrp || "",
      months: form.months ? Number(form.months) : "",
      duration: form.duration ? Number(form.duration) : "",
      order_no: form.order_no || "",
      description: form.description || "",
      sub_img: null,
      imagePreview: form.sub_img ? `https://api.sweepydo.in/uploads/${form.sub_img}` : ""
    });
    setSelectedServices(parsedServices);
    setEditingCompanyId(form.id);
    setShowForm(true);
  };
  const handleDelete = async id => {
    try {
      await axios.delete(`https://api.sweepydo.in/delete-subscription-plan/${id}`);
      showToast("Subscription plan deleted successfully", "success");
      fetchPlan();
    } catch (err) {
      console.error("Error deleting role:", err);
      showToast("Failed to delete Subscription plan", "danger");
    }
  };
  const fetchService = async () => {
    try {
      const res = await axios.get("https://api.sweepydo.in/fetch-service");
      const serviceOptions = res.data.map(service => ({
        value: service.id,
        label: service.name,
        mrp: service.mrp,
        sale_price: service.sale_price
      }));
      setServices(serviceOptions);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchPlan = async () => {
    try {
      const res = await axios.get("https://api.sweepydo.in/fetch-subscription-plan");
      setPlan(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchService();
    fetchPlan();
  }, []);
  const resetForm = () => {
    setFormData({
      name: "",
      code: '',
      sale_price: "",
      mrp: '',
      months: '',
      duration: '',
      service_name: '',
      imagePreview: '',
      order_no: '',
      description: ''
    });
    setSelectedServices([{
      sId: "",
      name: "",
      sale_price: 0,
      no_times: 1
    }]);
  };
  const handleToggleStatus = async id => {
    try {
      await axios.put(`https://api.sweepydo.in/toggle-plan-status/${id}`);
      showToast("Status updated!", "success");
      fetchPlan();
    } catch (err) {
      console.error(err);
      showToast("Failed to update status", "danger");
    }
  };
  const filteredData = Array.isArray(plans) ? plans.filter(itm => {
    if (statusFilter === "active") return itm.is_active === 0;
    if (statusFilter === "inactive") return itm.is_active === 1;
    return true; // all
  }).filter(itm => Object.values(itm).some(val => String(val).toLowerCase().includes(searchTerm.toLowerCase()))) : [];
  return <>
   <div className="container-fluid mt-3 px-2 px-md-3">
 <ToastNotification show={toast.show} message={toast.message} bg={toast.bg} onClose={() => setToast({
        ...toast,
        show: false
      })} />
      <h2 className="text-center mb-4 text-white">Subscription Plan </h2>

<div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">

  {/* LEFT SIDE */}
  <input type="text" className="form-control" placeholder="Search services..." style={{
          width: "100%",
          maxWidth: "300px",
          ...inputStyle
        }} value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />

  {/* RIGHT SIDE */}
  <div className="d-flex gap-2 align-items-center ms-auto">

    <select className="form-select" value={statusFilter} onChange={e => setStatusFilter(e.target.value)} style={{
            width: "180px",
            background: "#1e293b",
            color: "#fff",
            border: "1px solid #334155"
          }}>
      
      <option value="active">Active Plans</option>
      <option value="inactive">Inactive Plans</option>
    </select>

    <Button variant="primary" onClick={() => setShowForm(true)}>
      <IoMdAddCircle /> Add
    </Button>

  </div>

</div>

       {showForm && <Card className="p-4 mb-4" style={{
        background: "var(--black)",
        borderRadius: "12px",
        border: "1px solid rgba(255,255,255,0.08)",
        boxShadow: "0 10px 30px rgba(0,0,0,0.4)"
      }}>
      <form onSubmit={handleSubmit}>
        <div className="row mb-3">
          <div className="col-lg-6 col-md-6 col-12">
            <label className="form-label text-white">Plan Name</label>
            <input type="text" name="name" value={formData.name} onChange={handleInputChange} className="form-control" required style={inputStyle} />
          </div>

          <div className="col-lg-6 col-md-6 col-12">
            <label className="form-label text-white">Plan Code</label>
            <input type="text" name="code" value={formData.code} onChange={handleInputChange} className="form-control" style={inputStyle} required />
          </div>
        </div>



            <div className="row mb-3">
         
          <div className="col-lg-6 col-md-6 col-12">
             <label className="form-label text-white">Select Month</label>
               <Select options={monthOptions} className="w-100" placeholder="Select month" classNamePrefix="custom-select" value={monthOptions.find(opt => opt.value === formData.months) || null} onChange={handleMonthChange} isClearable required />
            </div> 


                         <div className="col-lg-6 col-md-6 col-12">
  <label className="form-label text-white">Daily work duration (in Mins)</label>

    <input type="text" name="duration" value={formData.duration} onChange={handleInputChange} className="form-control" style={inputStyle} required />

</div>

        </div>





        <div className="row mb-3">
         

          <div className="col-lg-6 col-md-6 col-12">
            <label className="form-label text-white">MRP</label>
            <input type="number" name="mrp" value={formData.mrp} onChange={handleInputChange} className="form-control" style={inputStyle} required />
          </div>

           <div className="col-lg-6 col-md-6 col-12">
            <label className="form-label text-white">Sale Price</label>
            <input type="number" name="sale_price" value={formData.sale_price} onChange={handleInputChange} className="form-control" style={inputStyle} />
          </div>
        </div>

   

    <div className="mb-5">
  <div className="d-flex justify-content-between mb-3">
  <label className="text-white">Select Services</label>
  <button type="button" className="btn btn-primary btn-sm" onClick={handleAddServiceRow}>
    + Add Service
  </button>
</div>

  {selectedServices.map((item, index) => <div key={index} className="d-flex gap-2 align-items-center mt-3">

      {/* Service Dropdown */}
      <select className="form-control" style={inputStyle} value={item.sId} onChange={e => handleServiceSelect(index, e.target.value)}>
        <option value="">Select Service</option>
        {services.map(s => <option key={s.value} value={s.value}>
            {s.label}
          </option>)}
      </select>

{/* Service Type */}
<select className="form-control" style={{
                width: "120px",
                ...inputStyle
              }} value={item.s_type} onChange={e => {
                const updated = [...selectedServices];
                updated[index].s_type = e.target.value;
                setSelectedServices(updated);
              }}>
  <option value="Daily">Daily</option>
  <option value="Weekly">Weekly</option>
   <option value="Monthly">Monthly</option>
</select>

      {/* Duration */}
      <input type="number" min="1" className="form-control" style={{
                width: "100px",
                ...inputStyle
              }} value={item.no_times} onChange={e => handleTimeChange(index, e.target.value)} />

      <span className="text-white col-1 text-center border rounded py-1">
        ₹{item.sale_price * item.no_times}
      </span>

      {/* Remove */}
      <button type="button" className="btn btn-danger btn-sm" onClick={() => handleRemoveServiceRow(index)}>
        Remove
      </button>
    </div>)}


</div>





        <div className="row mb-3">
  <div className="col-lg-6 col-md-6 col-12">
    <label className="form-label text-white">Upload Image</label>

    <input type="file" accept="image/*" name="sub_img" className="form-control" style={inputStyle} required={!isEditMode} onChange={e => {
                const file = e.target.files[0];
                if (file) {
                  setFormData({
                    ...formData,
                    sub_img: file,
                    imagePreview: URL.createObjectURL(file)
                  });
                }
              }} />

    {/* Preview */}
    {formData.imagePreview && <div className="mt-3">
    

        {/* View Button */}
        <div className="mt-2">
          <button type="button" className="btn btn-sm btn-info" onClick={() => window.open(formData.imagePreview, "_blank")}>
            View Image
          </button>
        </div>
      </div>}
  </div>

    <div className="col-lg-6 col-md-6 col-12">
            <label className="form-label text-white">Plan Order No.</label>
            <input type="text" name="order_no" value={formData.order_no} onChange={handleInputChange} className="form-control" style={inputStyle} required />
          </div>

<div className="col-lg-6 col-md-6 col-12 mt-2">
    <label className="form-label text-white">Description</label> <br />
    <textarea name="description" value={formData.description} onChange={handleInputChange} className="form-control" rows="4" placeholder="Enter  description..." style={inputStyle} />
</div>

</div>



        <div className="d-flex justify-content-end mb-2">
         
          <Button type="submit" variant="success">
            {isEditMode ? "Update" : "Save"}
          </Button>

           <Button variant="danger" onClick={handleCancel} className="ms-2">
            Cancel
          </Button>
        </div>
      </form>
    </Card>}


<div className="container mt-5 mb-3">
  <div className="row justify-content-start g-4">
    {filteredData.map(plan => <div key={plan.id} className="col-auto">
  <div className="card text-white position-relative d-flex flex-column" style={{
              width: "250px",
              height: "300px",
              borderRadius: "16px",
              backgroundColor: "var(--boxColor)",
              boxShadow: "0 8px 20px rgba(0,0,0,0.5)",
              padding: "12px"
            }}>

    <div className="position-absolute top-0 start-0 m-2 px-2 py-1" style={{
                background: "#0d6efd",
                color: "#fff",
                borderRadius: "8px",
                fontSize: "12px",
                fontWeight: "600",
                zIndex: 2
              }}>
 SR:{plan.order_no || "-"}
</div>

    {/* ACTION BUTTONS */}
    <div className="position-absolute top-0 end-0 p-2 d-flex gap-2">
      <div className="p-1 rounded" style={{
                  cursor: plan.id == 0 ? "not-allowed" : "pointer",
                  background: "rgba(0,0,0,0.4)",
                  opacity: plan.id == 0 ? 0.5 : 1
                }} onClick={() => {
                  if (plan.id == 0) return;
                  handleEdit(plan);
                }}>
  <FaEdit className="text-white" />
</div>



      <div className="p-1 rounded" style={{
                  cursor: "pointer",
                  background: "rgba(0,0,0,0.4)"
                }}>
  <RiChatDeleteLine className="text-white" size={20} cursor="pointer" title={plan.is_active == 0 ? "Deactivate Plan" : "Activate Plan"} className={` ${plan.is_active == 0 ? "text-warning" : "text-secondary"}`} onClick={() => {
                    setSelectedStaff(plan);
                    setShowStatusModal(true);
                  }} />
</div>
    </div>



    {/* BODY */}
    <div className="d-flex flex-column h-100 mt-4">

      {/* TITLE */}
      <h6 className="fw-bold text-center mb-1">{plan.name} {plan.order_no} </h6>
      <small className="text-secondary fw-semibold text-center mb-3">
        {plan.code}
      </small>

      <hr className="text-white my-2" />

      {/* CONTENT AREA (Aligned like Able Pro) */}
      <div className="flex-grow-1">

        <div className="d-flex justify-content-between mb-2">
          <span className="text-secondary">Duration</span>
          <span>
            {plan.months} month{plan.months > 1 ? "s" : ""}
          </span>
        </div>

          <div className="d-flex justify-content-between mb-2">
          <span className="text-secondary">Work Time</span>
          <span>
            {plan.duration} mins
          </span>
        </div>

            <div className="d-flex justify-content-between mb-2"> 
                <span className="text-secondary">Price</span>
                <span>  ₹{plan.sale_price} <small className="ms-2 fw-semibold text-decoration-line-through text-secondary">₹{plan.mrp}</small> </span>
           </div>
           

        <div className="d-flex justify-content-between">
          <span className="text-secondary">Services</span>
        </div>

        <div className="small text-secondary mt-1"
                  // style={{
                  //   maxHeight: "60px",
                  //   overflow: "hidden"
                  // }}
                  >
        

<div className="text-white">
  {(() => {
                        const services = typeof plan.service_name === "string" ? JSON.parse(plan.service_name) : plan.service_name || [];
                        if (!Array.isArray(services) || services.length === 0) return "-";
                        const visible = services.slice(0, 3);
                        const remaining = services.length - 3;
                        return <>
        {visible.map(s => s.name).join(", ")}
        {remaining > 0 && <span>.. +{remaining} more</span>}
      </>;
                      })()}
</div>
        </div>

      </div>

 {showStatusModal && <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content" style={{
                      backgroundColor: "var(--black2)",
                      color: "#fff"
                    }}>

              <div className="modal-header">
                <h5 className="modal-title">Mark {selectedStaff.is_active == 0 ? 'Inactive' : 'Active'}</h5>
                <button type="button" className="btn-close" onClick={() => setShowStatusModal(false)}></button>
              </div>

              <div className="modal-body">
                <p>Are you sure you want to change this plan status?</p>
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowStatusModal(false)}>
                  Cancel
                </button>

                <button className="btn btn-warning" onClick={() => {
                          handleToggleStatus(selectedStaff.id);
                          setShowStatusModal(false);
                        }}>
                  Yes, Change
                </button>
              </div>

            </div>
          </div>
        </div>}

    </div>
  </div>

    <ConfirmDialog show={confirmDialog.show} title={confirmDialog.title} message={confirmDialog.message} onConfirm={confirmDialog.onConfirm} onCancel={() => setConfirmDialog({
              ...confirmDialog,
              show: false
            })} />
</div>)}
  </div>
</div>


  </div>

  
   </>;
};
export default SubscriptionPlan;
